import React from 'react'
import { colors, Divider, LayoutBand, Paragraph, Row, Separator, usePageWidth } from '@fs/zion-ui'

import QuoteCircle from './QuoteCircle'

export default function TestimonialSection({ quote, author, location, color = colors.gray100, backgroundColor }) {
  const isMobile = usePageWidth()({ default: true, md: false })

  return (
    <LayoutBand maxWidth="sm" marginY={isMobile ? 'xxl' : 'xl'}>
      <Row alignX="center">
        <QuoteCircle color={color} backgroundColor={backgroundColor} />
      </Row>
      <Separator size="xl" />
      <div>
        <Paragraph centered balanced size="lg">
          <strong>{quote}</strong>
        </Paragraph>
        <div style={{ maxWidth: '100px', margin: '0 auto' }}>
          <Divider marginY="md" />
        </div>
        <Paragraph centered>
          <strong>{author}</strong>
        </Paragraph>
        {location && (
          <>
            <Separator size="nano" />
            <Paragraph centered>{location}</Paragraph>
          </>
        )}
      </div>
    </LayoutBand>
  )
}
